import script from "./CoinSearchView.vue?vue&type=script&setup=true&lang=js"
export * from "./CoinSearchView.vue?vue&type=script&setup=true&lang=js"

import "./CoinSearchView.vue?vue&type=style&index=0&id=a561c8e0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a561c8e0"]])

export default __exports__